;define(
    function (require) {
        var $ = require('jquery');
        var Cookie = require('cookie');
        var cookieNames = {
            face: 'face'                 // 风格
        }
        var cookieOptions = {expires : 30, path : '/'};
        var customRadioCheckbox = function($wrap) {
            $wrap.customRadioCheckbox();
        };

        var blurBgImg = function() {
            /* globals SYS_CONST, CUSTOME_DATA, DATA */
            window.SYS_CONST = window.SYS_CONST || {};
            window.CUSTOME_DATA = window.CUSTOME_DATA || {};
            var indexData = CUSTOME_DATA.indexPageData2 || {};
            var isCustomizeBg = false;
            var imgUrlPrefix = '';
            var faceSetting = SYS_CONST.faceSetting;

            // 未定制情况下indexData为空，根据该条件做区分
            if (!$.isEmptyObject(indexData)) {
                var realResource = indexData.real_resource || {};
                window.DATA = $.extend(true, {}, realResource, {orgId: indexData.org ? indexData.org : ''});
                DATA.facade_custom = DATA.facade_custom || {};
                var copyrightText = DATA.facade_custom.copyright_text;
                if (copyrightText) {
                    DATA.facade_custom.copyright_text = copyrightText.replace(/&/g, '&amp;').replace(/>/g, '&gt;')
                            .replace(/</g, '&lt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace('&amp;copy;', '&copy;');
                }
                // 定制背景
                isCustomizeBg = DATA.facade_custom.background && DATA.facade_custom.background.length !== 0;

                imgUrlPrefix = location.protocol + '//'+ location.host +'/@context.name@/s?func=lp:getImg&org_id=' + DATA.orgId + '&img_id=';
                // 通过构造样式文件来实现样式定制
                _makeCustomizeStyle(DATA, isCustomizeBg, imgUrlPrefix);
                // 设置浏览器tab的title以及icon
                _setTabTitleFavor(DATA, imgUrlPrefix);
            }

            function _makeCustomizeStyle(data, isCustomizeBg, imgUrlPrefix) {
                var styleStr = '';

                styleStr += _makeStyleBlockStr('label.slogan', {
                    'color': data.facade_custom.slogan_color,
                    'font-size': data.facade_custom.slogan_fontsize ? data.facade_custom.slogan_fontsize + 'px' : ''
                });
                styleStr += _makeStyleBlockStr('div.main-bottom', {
                    'background-color': data.facade_custom.background_color
                });
                if (isCustomizeBg) {
                    styleStr += _makeStyleBlockStr('div.main-bottom', {
                        'background-image': 'url(' + imgUrlPrefix + data.facade_custom.background[0] + ')',
                        'filter': 'progid:DXImageTransform.Microsoft.AlphaImageLoader(src="'+ imgUrlPrefix + data.facade_custom.background[0] + '", sizingMethod="scale")'
                    });
                }
                styleStr += _makeStyleBlockStr('button.u-btn', {
                    'background-color': data.facade_custom.submit_button_color,
                    'color': data.facade_custom.submit_button_font_color
                });

                $('#dHead').append($('<style type="text/css">' + styleStr + '</style>'));
            }

            function _makeStyleBlockStr(selector, items) {
                var result = '';
                if ($.isEmptyObject(items)) {
                    return result;
                }

                result += selector + '{';
                $.each(items, function(key, value) {
                    if (value) {
                        result += key + ':' + value + ';';
                    }
                });
                result += '}';

                return result;
            }

            function _setTabTitleFavor(data, imgUrlPrefix) {
                if (data.facade_custom.favor_title) {
                    document.title = data.facade_custom.favor_title;
                }
                if (data.facade_custom.favor && data.facade_custom.favor.length !== 0) {
                    var favorUrl = imgUrlPrefix + data.facade_custom.favor[0] + '&hash=' + Math.random();
                    var link = document.createElement('link');
                    link.type = 'image/x-icon';
                    link.rel = 'shortcut icon';
                    link.href = favorUrl;
                    document.getElementsByTagName('head')[0].appendChild(link);
                }
            }
            Cookie.set(cookieNames.face, faceSetting || 'XT5', cookieOptions);

            if (!isCustomizeBg) {
                var num = Math.round(Math.random() * 3);
                $('.main-bottom').addClass('main-bottom-' + num);
                $('.main-middle').addClass('main-middle-' + num);
            }
            if (!(/MSIE (6|7)/i).test(navigator.userAgent)) {
                setTimeout(function() {
                    $('.aside-blur').blurjs({
                        source: '.main-bottom',  //模糊背景的selector
                        radius: 5,               //模糊半径
                        cacheExpired: 30 * 1000,
                        cache: false
                    });
                }, 500);

            }
        };

        /**
         * 毛玻璃图片
         * 参考：https://github.com/jakiestfu/Blur.js
         *
         * 在原仓库的基础上，将核心的计算过程移到独立脚本，由WebWorker 运行，避免UI 线程被阻塞
         * */
        $.fn.blurjs = function (options) {
            options.cacheExpired = options.cacheExpired || Number.MAX_VALUE;
            var curMS = (new Date()).getTime();
            var canvas = document.createElement('canvas');
            var isCached = false;
            var selector = ($(this).selector).replace(/[^a-zA-Z0-9]/g, '');

            // 为了保证需求和性能，毛玻璃图片只在同时支持canvas 和WebWorker 的浏览器生效
            if (!canvas.getContext || !('Worker' in window)) {
                return;
            }
            options = $.extend({
                source: 'body',
                radius: 5,
                overlay: '',
                offset: {
                    x: 0,
                    y: 0
                },
                optClass: '',
                cache: false,
                cacheKeyPrefix: 'blurjs-',
                draggable: false,
                debug: false
            }, options);

            function stackBlurCanvasRGB(a, b, c, d, f, g) {
                var dfd = $.Deferred();
                var worker = require('worker-loader!./blurImg_worker')();

                if (isNaN(g) || g < 1) return;
                g |= 0;
                var h = a.getContext('2d');
                var j;
                try {
                    try {
                        j = h.getImageData(b, c, d, f)
                    } catch (e) {
                        try {
                            // eslint-disable-next-line no-undef
                            netscape.security.PrivilegeManager.enablePrivilege('UniversalBrowserRead');
                            j = h.getImageData(b, c, d, f)
                        } catch (e) {
                            alert('Cannot access local image');
                            throw new Error('unable to access local image data: ' + e);
                        }
                    }
                } catch (e) {
                    alert('Cannot access image');
                    throw new Error('unable to access image data: ' + e);
                }

                worker.onmessage = function(e) {
                    var data = e.data;

                    if (data.type === 'afterCal') {
                        h.putImageData(data.j, b, c);
                        return dfd.resolve();
                    }
                };

                worker.postMessage({
                    type: 'cal',
                    d: d,
                    j: j,
                    g: g,
                    f: f
                });

                return dfd.promise();
            }

            return this.each(function () {
                var $glue = $(this);
                var $source = $(options.source);
                var formattedSource = ($source.css('backgroundImage')).replace(/"/g, '').replace(/url\(|\)$/ig, '');
                var ctx = canvas.getContext('2d');
                var tempImg = new Image();
                var cachedDate;
                tempImg.onload = function () {
                    function afterDone(blurredData) {
                        var attachment = $source.css('backgroundAttachment');
                        var position = (attachment === 'fixed') ? '' : '-' + (($glue.offset().left) - ($source.offset().left) - (options.offset.x)) + 'px -' + (($glue.offset().top) - ($source.offset().top) - (options.offset.y)) + 'px';
                        $glue.css({
                            'background-image': 'url("' + blurredData + '")',
                            'background-repeat': $source.css('backgroundRepeat'),
                            'background-position': position,
                            'background-attachment': attachment
                        });
                        if (options.optClass !== false) {
                            $glue.addClass(options.optClass);
                        }
                        if (options.draggable) {
                            $glue.css({
                                'background-attachment': 'fixed',
                                'background-position': '0 0'
                            });
                            $glue.draggable();
                        }
                    }
                    if (!isCached) {
                        canvas.style.display = 'none';
                        canvas.width = tempImg.width;
                        canvas.height = tempImg.height;
                        ctx.drawImage(tempImg, 0, 0);
                        stackBlurCanvasRGB(canvas, 0, 0, canvas.width, canvas.height, options.radius).then(function() {
                            if (options.overlay) {
                                ctx.beginPath();
                                ctx.rect(0, 0, tempImg.width, tempImg.width);
                                ctx.fillStyle = options.overlay;
                                ctx.fill();
                            }
                            var blurredData = canvas.toDataURL();
                            if (options.cache) {
                                try {
                                    if (options.debug) {
                                        console.log('Cache Set');
                                    }
                                    localStorage.setItem(options.cacheKeyPrefix + selector + '-' + formattedSource + '-data-image', blurredData);
                                    cachedDate = localStorage.setItem(options.cacheKeyPrefix + selector + '-' + formattedSource + '-data-image-cacheAt', curMS);
                                } catch (e) {
                                    console.log(e);
                                }
                            }
                            afterDone(blurredData);
                        });
                    } else {
                        afterDone(tempImg.src);
                    }
                };
                Storage.prototype.cacheChecksum = function (opts) {
                    var newData = '';
                    for (var key in opts) {
                        var obj = opts[key];
                        if (obj.toString() === '[object Object]') {
                            newData += ((obj.x).toString() + (obj.y).toString() + ',').replace(/[^a-zA-Z0-9]/g, '');
                        } else {
                            newData += (obj + ',').replace(/[^a-zA-Z0-9]/g, '');
                        }
                    }
                    var originalData = this.getItem(options.cacheKeyPrefix + selector + '-' + formattedSource + '-options-cache');
                    if (originalData !== newData) {
                        this.removeItem(options.cacheKeyPrefix + selector + '-' + formattedSource + '-options-cache');
                        this.setItem(options.cacheKeyPrefix + selector + '-' + formattedSource + '-options-cache', newData);
                        if (options.debug) {
                            console.log('Settings Changed, Cache Emptied');
                        }
                    }
                };
                var cachedData = null;
                if (options.cache) {
                    localStorage.cacheChecksum(options);
                    cachedDate = localStorage.getItem(options.cacheKeyPrefix + selector + '-' + formattedSource + '-data-image-cacheAt');
                    var internalDate = parseInt(curMS) - parseInt(cachedDate);
                    if (internalDate > 0 && internalDate < options.cacheExpired) {
                        cachedData = localStorage.getItem(options.cacheKeyPrefix + selector + '-' + formattedSource + '-data-image');
                    }
                }
                if (cachedData != null) {
                    if (options.debug) {
                        console.log('Cache Used');
                    }
                    isCached = true;
                    tempImg.src = (cachedData);
                } else {
                    if (options.debug) {
                        console.log('Source Used');
                    }
                    tempImg.src = formattedSource;
                }
            });
        };

        /*!
         * jQuery Custom Radio Checkbox Plugin
         * Copyright (c) 2012-2014 Denis Ciccale (@tdecs)
         * Released under MIT license (https://raw.github.com/dciccale/Custom-radio-checkbox/master/LICENSE.txt)
         */
        $.fn.customRadioCheckbox = function (/*options*/) {
            // don't act on absent elements, can't chain anyway
            if (!this[0]) {
                return;
            }

            // checked suffix
            var checkedSuffix = '-checked';

            // css class used to hide inputs
            var hiddenInputClass = 'rc-hidden';

            var disabledClass ='rc-disabled';

            // function to force the input change when clicking
            // on a fake input that is not wrapped by a label tag
            var forceChange = function () {
                var $this = $(this);
                // only trigger if the input is not inside a label
                if (!$this.closest('label')[0]) {
                    $this.prev().trigger('change.crc', [true]);
                }
            };

            // function that inserts the fake input
            var insertFakeInput = function (inputs) {
                var type = inputs.type;
                var l = inputs.length;
                var isDisable;
                var fakeInputElem, input;

                while (l--) {
                    // current input
                    input = inputs[l];
                    isDisable = $(input).prop('disabled');

                    // fake input
                    fakeInputElem = $('<i>')
                            .addClass(type + (input.checked ? ' ' + type + checkedSuffix : ''));

                    fakeInputElem.bind('click.crc', forceChange);
                    isDisable && fakeInputElem.addClass(disabledClass);

                    // insert the fake input after the input
                    input.parentNode.insertBefore(fakeInputElem[0], input.nextSibling);
                }
            };

            return this.each(function () {

                var $context = $(this);

                // find & hide radios
                var rds = $context.find('input[type=radio]:not(.' + hiddenInputClass + ')')
                        .addClass(hiddenInputClass);

                // find & hide checkboxes
                var chs = $context.find('input[type=checkbox]:not(.' + hiddenInputClass + ')')
                        .addClass(hiddenInputClass);

                // storage for each radio group to optimize next lookup
                var rdsCache = {};

                // total radios
                var rdsLength = rds.length;
                var rd;

                // only apply if there are radios
                if (rds.length) {
                    rds.type = 'radio';

                    // insert each fake radio
                    insertFakeInput(rds);

                    // initialize rdsCache for prechecked inputs
                    while (rdsLength--) {
                        rd = rds[rdsLength];
                        if (rd.checked) {
                            (rdsCache[rd.name] = {}).checked = $(rd.nextSibling);
                        }
                    }

                    // bind radio change event
                    rds.bind('change.crc', function (e, force) {
                        if ($(this).prop('disabled')) {
                            return false;
                        }
                        // uncheck previous and remove checked class
                        if (!force || !this.checked) {

                            // filter by name and remove class from the last radio checked
                            // save this collection in cache obj for faster use
                            if (!rdsCache[this.name]) {
                                rdsCache[this.name] = {};
                            }

                            // uncheck last checked from this group
                            if (rdsCache[this.name].checked) {
                                rdsCache[this.name].checked.removeClass(rds.type + checkedSuffix);
                            }

                            // add checked class to this input and save it as checked for this group
                            rdsCache[this.name].checked = $(this.nextSibling).addClass(rds.type + checkedSuffix);
                        }

                        // if force set to true and is not already checked, check the input
                        if (force && !this.checked) {
                            this.checked = true;
                        }
                    });
                }

                // only apply if there are checkboxes
                if (chs.length) {
                    chs.type = 'checkbox';

                    // insert each fake checkbox
                    insertFakeInput(chs);

                    // bind checkbox change event
                    chs.bind('change.crc', function (e, force) {
                        if ($(this).prop('disabled')) {
                            return false;
                        }
                        // force change state
                        if (force) {
                            this.checked = !this.checked;
                        }

                        // toggle checked class
                        $(this.nextSibling).toggleClass(chs.type + checkedSuffix);
                    });
                }
            });
        };

        return {
            customRadioCheckbox: customRadioCheckbox,
            blurBgImg: blurBgImg
        };
    }
);



/*****************
 ** WEBPACK FOOTER
 ** ./web.modules/coremail.framework/src/common/assets/index_cmxt50/js/components.js
 ** module id = 155
 ** module chunks = 15
 **/